export default __webpack_public_path__ + "static/media/mobile_07.639081f5.png";